import { Task } from "@companies/shared/types/task";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useTasks } from "../../queries/task";
import { useTimes } from "../../queries/time";
import { HorizontalBarChart } from "../horizontal-bar-chart";
import { Column, Filter, SuffixRow, Table } from "../table";

export function ReportTasks({ project }: { project: string }) {
  const [searchParams, setSearchParams] = useSearchParams();

  function updateSearchParams(params: Record<string, string>) {
    setSearchParams({
      ...Object.fromEntries(searchParams.entries()),
      ...params,
    });
  }

  const { data: tasks } = useTasks(project);
  const { data: times } = useTimes({
    project,
    from: new Date("2026-01-01"),
    to: new Date("2026-12-31"),
  });
  const [sortBy, setSortBy] = useState<{
    field: string;
    direction: "asc" | "desc";
  }>({ field: "from", direction: "desc" });

  return (
    <div>
      <Table
        data={times || []}
        filterBy={JSON.parse(searchParams.get("filterBy") || "[]") as Filter[]}
        groupBy="task"
        sortBy={sortBy.field}
        sortByDirection={sortBy.direction}
        onFilter={(value: Filter[]) => {
          updateSearchParams({
            filterBy: JSON.stringify(value),
          });
        }}
        onSort={(field, direction) => setSortBy({ field, direction })}
      >
        <Column field="from" filterableBy="date">
          Date
        </Column>
        <Column field="hours">Hours</Column>
        <Column field="description">description</Column>
      </Table>
      <HorizontalBarChart
        data={{
          labels: tasks?.map((task) => task.name) || [],
          datasets: [
            {
              data: tasks?.map((task) => task.hours) || [],
            },
          ],
        }}
        options={{
          animation: false,
          plugins: {
            legend: {
              display: false,
            },
          },
        }}
      />
    </div>
  );
}
